export default function delay(ms: number, callback: Function): Promise<void> {
    return new Promise(function (resolve) {
        setTimeout(() => {
            callback();
            resolve();
        }, ms);
    });
}
